<template>
  <div class="w100 pl10 pr10 pt10 pb10 flex-box">
    <div class="mr20 flex-box flex-col role-box" v-loading="loading1">
      <div class="pt10 pb10 pl10 pr10 bor-l bor-r bor-t flex-box al-c">
        <div style="marginRight: 6px">关键字</div>
        <el-input
          v-model="keywords"
          placeholder="请输入内容"
          size="mini"
          style="width: 140px"
          clearable
          @change="initReportList"
        ></el-input>
        <el-button size="mini" type="primary"
                   style="marginLeft: auto"
                   @click="handleAdd">新建任务</el-button>
      </div>
      <div class="flex-1 pt10 pb10 pl10 pr10 of-y bor-l bor-r bor-b role-list" >
        <TaskCard v-for="item in reportList" :key="item.id" :cardData="item" @click.native="cardClick(item)" :activeReport="activeReport"/>
      </div>
      <div class="task-pagination">
          <el-pagination
            small
            layout="prev, pager, next"
            :pager-count="5"
            :current-page.sync="reportListPagination.current"
            @current-change="taskPageChange"
            :total="reportListPagination.total">
          </el-pagination>
        </div>
    </div>

    <div class="flex-1 w100 h100 tabs-main">
      <div class="w100 flex-box ju-sb head-tab rightHead al-b mb5">
        <div class="headTitle">任务详情</div>
        <div class="flex-box controller pb10" v-if="activeReport.id">
          <!-- <div @click="addOk"><i class="el-icon-bell"></i>催办</div> -->
          <div @click="pause"><i :class="activeReport.status == '2' ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>{{activeReport.status == '2' ? '取消暂停' : '暂停任务'}}</div>
          <div @click="delTask"><i class="el-icon-delete"></i>删除任务</div>
          <div @click="editTask"><i class="el-icon-edit"></i>编辑任务</div>
          <div @click="addUser"><i class="el-icon-user"></i>追加人员</div>
          <div @click="batchDelete"><i class="el-icon-delete"></i>批量删除</div>
          <!-- <div @click="hastenWork"><i class="el-icon-bell"></i>催办</div> -->
        </div>
      </div>
      <div class="report-content pt10" v-if="activeReport.id">
        <div class="report-name">{{activeReport.reportName}}</div>
        <div class="report-info mb10 flex-box ju-sb al-c">
          <div class="flex-box info">
            <div>发起部门: {{activeReport.deptName}}</div>
            <div>发起人: {{activeReport.userName}}</div>
            <div style="color:#49A0FA">{{`${activeReport.readUserNum}人已读/${activeReport.reportUserNum}人已上报/${activeReport.reportUserTotal}人`}}</div>
          </div>
          <div style="color:#838385">起止时间：{{activeReport.beginTime}} -- {{activeReport.endTime}}</div>
        </div>
        <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage" >
          <el-col class="flex-box al-c" :span="6">
            <div class="flex-box al-c mb10">
              <span class="mr10 tx-r" style="width: 70px;">部门</span>
              <el-input
                v-model="dep.name"
                @focus="showDeptDialog"
                :readonly="true"
                placeholder="请选择部门"
              ></el-input>
            </div>
            <el-button class="mb10 ml10" type="primary" @click="initPage">查询</el-button>
             <!--<el-button class="mb10 ml10" :disabled="multipleSelection.length == 0" type="primary" @click="expotCli">批量下载</el-button>-->
          </el-col>
        </Sift>

        <div class="table-con" v-loading="loading2">
          <el-table class="w100 mt20 table" header-row-class-name="table-head" row-class-name="cu-p" stripe height="100%" :data="userList" @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
            <el-table-column align="center" type="index" label="序号"></el-table-column>
            <el-table-column align="center" prop="deptName" label="所属部门"></el-table-column>
            <!-- <el-table-column align="center" prop="userCode" label="工号"></el-table-column> -->
            <el-table-column align="center" prop="userName" label="姓名"></el-table-column>
            <el-table-column align="center" label="上报进度">
              <template slot-scope="scope">
                {{scope.row.reportStatus == '0' ? '未上报' : '已上报'}}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="readTime" label="已读时间"></el-table-column>
            <el-table-column align="center" prop="reportTime" label="上报时间"></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <div class="to-use">
                  <span class="danger" @click="deleteOne(scope.row)">删除</span>
                  <span class="info"  v-if="scope.row.reportStatus==1"  @click="getBpmnNoticeVisitUrl(scope.row)">编辑</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="mt20 flex-box">
          <div class="flex-1"></div>
          <el-pagination
                  background
                  :current-page="userListPagination.pageNum"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="userListPagination.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="userListPagination.total"
                  @size-change="changeSize"
                  @current-change="changePage"></el-pagination>
        </div>
      </div>

      <div class="empty" v-else>
        <div>暂无数据</div>
      </div>

      <AddOrEdit ref="addOrEdit" @onTaskSubmit="onTaskSubmit"/>
      <DepTree ref="DetTree" :propData="propData" @backFn="setDepData" />
      <ChargePerson
        ref="personModal"
        :personData="personData"
        @closePerson="closePerson"
      />
      <el-dialog
              title="下载标题"
              :visible.sync="dialogVisible"
              width="30%">
              <el-input v-model="names"></el-input>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="subClick">确 定</el-button>
              </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import TaskCard from '@/components/management/reportManage/taskCard';
import AddOrEdit from '@/components/management/reportManage/addOrEdit';
import ChargePerson from '@/components/management/reportManage/chargePerson';
import DepTree from "@/components/management/user/DepTree";
import {tHallBatchReportList, tHallBatchReportListUsers, tHallBatchReportStatus, tHallBatchReportSaveUsers, tHallBatchReportDeleteUsers,deleteReportId} from '@/api/management/report'
import {bpmnNoticeVisitUrl} from '@/api/bpmnApi/bpmn';
import {mapGetters} from "vuex";
import * as orignAxios from 'axios'
export default {
  name: "reportManage",
  components: {
    TaskCard,
    Sift,
    AddOrEdit,
    DepTree,
    ChargePerson,
  },
  props: [],
  data() {
    return {
      reportList: [],
      userList: [],
      loading1: false,
      loading2: false,
      reportListPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      userListPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      multipleSelection: [],
      siftData: [
        {
          type: "text",
          key: "keywords",
          label: "关键字",
          placeholder: "",
          default: "",
          col: 4
        },
        {
          type: "select",
          key: "reportStatus",
          label: "上报进度",
          placeholder: "",
          default: "",
          data: [
            {label: '未上报', value: '0'},
            {label: '已上报', value: '1'},
            // {label: '已上报', value: '2'},
          ],
          col: 4
        },
        {
          type: "bedate",
          key: "start,end",
          label: "上报时间",
          placeholder: "",
            defaultValue: "",
            pickerType: 'date', // 传给时间组件的type = week、month、year、date
            sysDatasourceQuery: true, //传给时间组件是否需要自选格式
          optionalType: "yyyy-MM-dd", // 需要的时间格式
          default: "",
          col:5
        },
      ],
      propData: [],
      dep: {
        id: "",
        name: "",
        parentId: "",
      },
      activeReport: {},
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: null
      },
      keywords: '',
        dialogVisible:false,
        names:''
    };
  },
  computed: {
    ...mapGetters([
      "chooseDept",
    ]),
  },
  created() {
    this.getReportList()
    this.getUserTree()
  },
  mounted() {},
  destroyed() {},
  methods: {
      subClick(){
          if(this.names){
              let params = {
                  downloadName: this.names,
                  insetIds: this.multipleSelection.map((item) =>{
                      return item.processInstId
                  }).join(',')
              }
              let url = 'gxdl/bpmn/batchDownloadAttach'
              this.downloadFn(url, params)
          }else {
              this.$message.error('请输入下载题目')
          }
      },
      expotCli(){
          if(this.multipleSelection.filter((item) => item.processInstId).length > 0){
              this.names = ''
              this.dialogVisible = true
          }else {
              this.$message.error('您选择的选项都未上报，请选上报')
          }

      },
      downloadFn(url,params){
          this.$DownLoadL(
              url,
              params,
              res => {
                  if (res.status == 200) {
                      this.dialogVisible = false
                  } else {
                      this.$alert("下载出错,请稍后重试", "提示", {
                          confirmButtonText: "确定",
                          type: "warning"
                      });
                  }
              },
              error => {
                  this.$alert(error, "提示", {
                      confirmButtonText: "确定",
                      type: "warning"
                  });
              }
          );
      },
    // 默认页面数据
    initPage() {
      this.userListPagination.pageNum = 1;
      this.getReportUsers();
    },
    // 条数
    changeSize(value) {
      this.userListPagination.pageSize = value;
      this.initPage();
    },
    // 上下页
    changePage(value) {
      this.userListPagination.pageNum = value;
      this.getReportUsers();
    },
    // 显示部门弹框
    showDeptDialog() {
      this.$refs.DetTree.dialogShow();
    },
    // 部门树
    getUserTree() {
      this.propData = this.chooseDept
    },
    // 设置选中的部门数据
    setDepData(data) {
      this.dep.id = data ? data.id : '';
      this.dep.name = data ? data.name : '';
      this.initPage();
    },
    pause(){
      if(this.activeReport.status == '2'){
        this.$confirm('是否取消暂停该任务', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          tHallBatchReportStatus({
            id: this.activeReport.id,
            status: '1'
          })
          .then(({data}) => {
            if(data.code == 0){
              this.$message.success('取消暂停成功')
              this.getReportList()
            }else {
              this.$message.error(data.msg)
            }
          })
          .catch(() => {
            this.$message.error('取消暂停失败')
          })
        })
      }else if(this.activeReport.status == '1') {
        this.$confirm('是否暂停该任务,暂停后用户将无法进行上报', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          tHallBatchReportStatus({
            id: this.activeReport.id,
            status: '2'  // 暂停
          })
          .then(({data}) => {
            if(data.code == 0){
              this.$message.success('暂停任务成功')
              this.getReportList()
            }else {
              this.$message.error(data.msg)
            }
          })
          .catch(() => {
            this.$message.error('暂停任务失败')
          })
        })
      }else {
        this.$message.warning('该任务不在进行中,无法暂停')
      }
    },
    editTask(){
      this.$refs.addOrEdit.dialogShow('edit', this.activeReport);
    },
    addUser(){
      this.personData.state = true;
    },
    batchDelete(){
      if (this.multipleSelection.length > 0) {
        this.$confirm(
          "确认要删除选中的人员吗?",
          "系统消息",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          let ids = '';
          this.multipleSelection.forEach((item, index) => {
            if(index != this.multipleSelection.length - 1){
              ids += (item.id + ',')
            }else {
              ids += item.id;
            }
          })
          tHallBatchReportDeleteUsers({
            reportId: this.activeReport.id,
            ids,
          })
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success("删除成功");
                this.initPage();
              } else {
                this.$notify({
                  title: "提示",
                  type: "warning",
                  message: `${res.data.msg}`
                });
              }
            })
            .catch(err => {
            });
        });
      } else {
        this.$message.closeAll();
        this.$message.warning("请选择目标项");
      }
    },
    hastenWork(){

    },
    reset(){

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getReportUsers(){
      this.loading2 = true;
        console.log( this.$refs.needSift.getValue());
        let searchData = this.$refs.needSift.getValue();
      let data = {
          beginDate: searchData.start|| '',
          endDate: searchData.end || '',
          keywords: searchData.keywords,
          reportStatus: searchData.reportStatus,
          current: this.userListPagination.pageNum,
          size: this.userListPagination.pageSize,
          reportId: this.activeReport.id,
          deptId: this.dep.id,
      }
      // Object.assign(data, searchData)
      tHallBatchReportListUsers(data).then(({data}) => {
        if(data.code == 0){
          this.userList = data.data.records;
          this.userListPagination.total = data.data.total;
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        this.loading2 = false
      })
    },
    taskPageChange(val){
      this.reportListPagination.pageNum = val;
      this.getReportList()
    },
    initReportList(){
      this.reportListPagination.pageNum = 1;
      this.getReportList()
    },
    getReportList(){
      this.loading1 = true
      let params = {
        keywords: this.keywords,
        size: this.reportListPagination.pageSize,
        current: this.reportListPagination.pageNum,
      }
      tHallBatchReportList(params)
      .then(({data}) => {
        this.reportList = data.data.records || []
        this.activeReport = data.data.records[0] || {}
        this.reportListPagination.total = data.data.total;
        this.loading1 = false;
      })
      .catch(() => {
        this.loading1 = false;
      })
    },
    cardClick(item){
      this.activeReport = item;
    },
    handleAdd(){
      this.$refs.addOrEdit.dialogShow('add');
    },
    onTaskSubmit(){
      this.getReportList();
    },
    closePerson(obj) {
      if (!obj.mans) {
        this.personData.state = false;
        return;
      }
      for (let i = 0; i < obj.data.length; i++) {
        if (isNaN(obj.data[i])) {
          obj.data.splice(i, 1);
        }
      }
      // if (obj.data.length > 0) {
      //   this.formValidate.userIds = obj.data;
      // }
      this.personData.userData = obj.data;
      this.personData.state = false;
      // this.planpermissionUserSubmit();
      if(obj.data.length == 0){
        this.$message.warning('请选择追加人员')
        return
      }
      let params = {
        reportId: this.activeReport.id,
        userId: obj.data
      }
      tHallBatchReportSaveUsers(params)
      .then(({data}) => {
        if(data.code == 0){
          this.getReportList()
          this.$message.success('操作成功')
        }else {
          this.$message.error(data.msg)
        }
      })
    },
    getBpmnNoticeVisitUrl(row){
      let params={
        taskId:row.taskInstId,
        instId:row.processInstId
      };
      bpmnNoticeVisitUrl(params).then(({data})=>{
        if(data.code==0){
          window.open(data.data)
        }else{
          this.$message.error(data.msg || '请求失败');
        }
      }).catch(err=>{
      })
    },
      addOk(){
          this.$confirm("确认要催办吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              callback: action => {
                  if (action === "cancel") {
                      return;
                  }
                  this.$message.success("催办成功");
              }
          });
      },
      delTask(){
          this.$confirm(
              `确认要删除${this.activeReport.reportName}填报任务吗?`,
              "提示",
              {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
              }
          ).then(() => {
              deleteReportId({
                  ids: this.activeReport.id,
              })
                  .then(res => {
                      if (res.data.code == 0) {
                          this.$message.success("删除成功");
                          this.getReportList();
                      } else {
                          this.$notify({
                              title: "提示",
                              type: "warning",
                              message: `${res.data.msg}`
                          });
                      }
                  })
                  .catch(err => {
                  });
          });
      },
    deleteOne(row){
      this.$confirm(
        `确认要删除${row.userName}吗?`,
        "系统消息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        tHallBatchReportDeleteUsers({
          reportId: this.activeReport.id,
          ids: row.id,
        })
          .then(res => {
            if (res.data.code == 0) {
              this.$message.success("删除成功");
              this.initPage();
            } else {
              this.$notify({
                title: "提示",
                type: "warning",
                message: `${res.data.msg}`
              });
            }
          })
          .catch(err => {
          });
      });
    }
  },
  watch: {
    activeReport(val){
      if(val.id){
        this.$nextTick(() => {
          this.initPage()
        })
      }
    }
  },
  filters: {}
};
</script>

<style scoped lang="less">
  @import "../../../assets/css/handleBtn.less";
.table-con {
  height: calc(100vh - 420px);
}
.tabs-main {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.role-box {
  width: 300px;
}
.head-tab {
  border-bottom: 2px solid #eee;
}
.task-pagination {
  margin-top: 10px;
  text-align: right;
}
.rightHead {
  height: 46px;
}
.headTitle {
  font-size: 16px;
  width: 92px;
  text-align: center;
  line-height: 28px;
  color: #074676;
  border-bottom: #074676 2px solid;
  font-weight: bold;
}
.controller > div {
  margin-right: 16px;
  cursor: pointer;
  > i {
    margin-right: 5px;
  }
}
.report-info {
  height: 36px;
  background-color: #F2F3F6;
  padding: 0 15px;
  .info > div {
    margin-right: 20px;
  }
}
.report-name {
  line-height: 36px;
  text-indent: 20px;
  position: relative;
}
.report-name::before {
  content: '';
  display: block;
  position: absolute;
  height: 16px;
  width: 2px;
  top: 9px;
  left: 6px;
  background-color: #074676;
}
.table {
  margin-top: 0 !important;
}
.empty {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #aaa;
}
</style>
